import React from "react"
import injectSheet from "react-jss"
import { Lightbox } from "@xingternal/360-components"
import { FencingCarousel } from "@/components"

const productIndex = {
  360: 0,
  xtm: 1,
  xtp: 2,
  jobs: 3,
  ebp: 5,
}

const fencingLightboxStyles = {
  lightbox: {
    paddingTop: 24,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0,
  },
}

const FencingLightbox = ({ classes, product, visible, onClose }) => (
  <Lightbox
    visible={visible}
    onClose={onClose}
    contentClassName={classes.lightbox}
  >
    <div style={{ height: "420px", minWidth: "600px", marginTop: "-16px" }}>
      <FencingCarousel initialSlide={productIndex[product]} />
    </div>
  </Lightbox>
)

FencingLightbox.defaultProps = {
  product: "360",
  visible: false,
  classes: {},
}

export const StyledFencingLightbox = injectSheet(fencingLightboxStyles)(
  FencingLightbox,
)
export default FencingLightbox
